// State behind Views/Shared/_ConfirmDialog.cshtml. The dialogs in this folder
// spread it and call show() with an async `action` to run on confirm.
export default () => ({
  open: false,
  busy: false,
  title: '',
  name: '',
  message: '',
  confirmLabel: 'Confirm',
  tone: 'danger',
  action: null,

  show({ title, name = '', message = '', confirmLabel, tone = 'danger', action }) {
    Object.assign(this, { title, name, message, confirmLabel, tone, action });
    this.open = true;
  },

  close() {
    if (!this.busy) {
      this.open = false;
    }
  },

  async confirm() {
    this.busy = true;

    try {
      // An action resolves to true when it navigates away, so the dialog stays busy.
      if (await this.action()) {
        return;
      }

      this.busy = false;
      this.close();
    } catch (error) {
      console.error(error);
      window.showErrorMessage('Something went wrong, please try again.');
      this.busy = false;
    }
  },
});
